import { render, staticRenderFns } from "./SimpleSet.vue?vue&type=template&id=f38aae26&lang=pug&"
import script from "./SimpleSet.vue?vue&type=script&lang=js&"
export * from "./SimpleSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports